import { AxiosError } from "axios";

import { CatchAsync } from "@/v1/types/ErrorHandler/CatchAsync.type";
import { ErrorResponse } from "@/v1/types/global";
import { useToastStore } from "@/v2/store/useToastStore";

import { IS_DEVELOPMENT, ToastModifier } from "./constants";

export const handleOnError = (error: unknown) => {
  // eslint-disable-next-line no-console
  if (IS_DEVELOPMENT) console.log("ERROR: ", error);

  const errorResponse = (error &&
    typeof error === "object" &&
    (error as AxiosError<ErrorResponse>)?.response?.data) as ErrorResponse;

  const shouldShowErrorMessage = (errorResponse && errorResponse.status < 500) || IS_DEVELOPMENT;

  let toastErrors = [
    {
      type: ToastModifier.ERROR,
    },
  ];

  if (
    shouldShowErrorMessage &&
    errorResponse &&
    errorResponse.errors &&
    errorResponse.errors.length > 0
  ) {
    toastErrors = errorResponse.errors.map((curError) => ({
      type: ToastModifier.ERROR,
      message: curError.message,
      duration: 15000,
    }));
  }

  toastErrors.forEach((toastError) => {
    useToastStore.setState({ toast: toastError });
  });
};

export const catchAsync: CatchAsync = (cb, customOptions) => {
  return async (...args) => {
    const hasErrorFunction = typeof customOptions === "function";
    let successData;

    try {
      successData = await cb(...args);

      if (!hasErrorFunction && customOptions?.onSuccessToast) {
        useToastStore.setState({
          toast: {
            type: ToastModifier.SUCCCESS,
            ...customOptions.onSuccessToast,
          },
        });
      }

      return successData;
    } catch (e) {
      if (hasErrorFunction) customOptions(e);
      else if (customOptions?.onError) customOptions.onError(e);
      handleOnError(e);
    } finally {
      if (!hasErrorFunction && customOptions?.onEnd) {
        customOptions.onEnd(successData);
      }
    }
  };
};
